<template>
  <b-modal 
    id="pre-charge"
    ref="preChargeRef"
    :hide-header="true"
    size="md">

    <form id="pre-charge-form">
      <h4 class="my-5" v-if="editMode === '+'">充值-{{this.company.nickname}}</h4>
      <h4 class="my-5" v-if="editMode === '-'">扣费-{{this.company.nickname}}</h4>
      <input type="hidden" name="company-code" :value="company.company_code">
      <div class="form-group row">
        <label for="nickname" class="col-6 col-form-label">客户名称</label>
        <div class="col-6">
          <input name="nickname" class="form-control input" :value="company.nickname" type="text" readonly>
        </div>
      </div>

      <div class="form-group row">
        <label for="charge-amount" class="col-6 col-form-label">金额</label>
        <div class="col-6 input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" v-if="editMode === '+'">+</span>
            <span class="input-group-text" v-if="editMode === '-'">-</span>
          </div>
          <input type="text" class="form-control" required name="charge-amount" v-validate="{ required: true,  min_value: 0 }" :class="{'is-invalid': errors.has('charge-amount')}">
          <div class="input-group-append">
              <span class="input-group-text">元</span>
            </div>
        </div>
      </div>

      <div class="form-group row">
        <label for="charge-type" class="col-6 col-form-label">
          <span v-if="editMode == '+'">充值</span>
          <span v-else>扣款</span>方式
        </label>
        <div class="col-6">
          <select class="custom-select" name="charge-type">
            <option value="bank_transfer" selected>银行转账</option>
            <option value="alipay">支付宝</option>
            <option value="wechatpay">微信支付</option>
            <option value="cash">现金支付</option>
          </select>
        </div>
        </div> 
      </div>

      <div class="form-group row">
        <div class="align-items-center col-sm">
          <textarea class="form-control" name="notes" rows=5 placeholder="备注, 最长200字" v-validate="{ required: true, max: 200}" :class="{'is-invalid': errors.has('notes')}"></textarea>
        </div>
      </div>
    </form>
    <div slot="modal-footer" class="w-100">
      <button class="btn btn-primary float-right mx-5 btn-disabled" @click="submitPreCharge" id="submit-pre-charge">提交</button>
      <button class="btn btn-secondary float-right" @click="$refs.preChargeRef.hide();">取消</button>
   </div>
  </b-modal>
</template>

<script>

function showPreChargeModal (company, editMode) {
  this.company = company
  this.editMode = editMode
  this.$refs.preChargeRef.show()
}

function submitPreCharge () {
  // validate form
  this.$validator.validateAll().then((result) => {
    if (!result) {
      return
    }

    // 禁用按钮
    if (document.getElementById('submit-pre-charge').disabled) {
      return
    } else {
      document.getElementById('submit-pre-charge').disabled = true
    }

    let form = document.getElementById('pre-charge-form')
    var object = {}
    new FormData(form).forEach((value, key) => {
      if (this.editMode === '-' && key === 'charge-amount'){
        value = - value
      }
      object[key.replace(/-/g, '_')] = value
    })

    this.$http.post('/api/pre_charges', object).then(response => {
      // 启用按钮，刷新页面
      setTimeout(() => {
        document.getElementById('submit-pre-charge').disabled = false
        this.$refs.preChargeRef.hide()
        this.$emit('refresh')
      }, 200)
    })
  })
}

export default {
  name: 'company-pre-charge',
  data () {
    return {
      'company': {},
      'editMode': '+'
    }
  },
  components: {
  },
  methods: {
    showPreChargeModal,
    submitPreCharge
  }
}

</script>